// STG QA 크레딧 지급 순수 로직 (B-2) — DOM/React 없이 테스트 가능한 계약만 모음.
// 컴포넌트(StgQaCreditButton/UserInlineDetail)는 이 함수들을 재사용한다.

export const STG_QA_MIN_NC = 1;
export const STG_QA_MAX_NC = 100000;

// 입력 검증 — 양수·상한·사유 3자+. (프론트 1차 방어, 백엔드가 최종 방어)
export function validateStgQaGrant({ amount, reason }) {
  const amtNum = parseInt(amount, 10);
  const amountValid =
    Number.isInteger(amtNum) && amtNum >= STG_QA_MIN_NC && amtNum <= STG_QA_MAX_NC;
  const reasonValid = String(reason ?? "").trim().length >= 3;
  return { amtNum, amountValid, reasonValid, valid: amountValid && reasonValid };
}

// 지급 성공 → 사용자 목록 갱신 콜백(onAdjusted)에 넘길 payload.
// 기존 PROD adminAdjust(CreditsSection.handleGrantSuccess)와 동일 계약: { userIds, amount }.
// amount 가 유효한 양수가 아니면 null 을 반환해 호출부가 목록 갱신을 건너뛰게 한다.
export function buildListAdjustPayload(userId, amount) {
  if (!userId) return null;
  const amt = Number(amount);
  if (!Number.isFinite(amt) || amt <= 0) return null;
  return { userIds: [userId], amount: amt };
}
